import { render, staticRenderFns } from "./PostFormMentionsLegalesManage.vue?vue&type=template&id=44787a88&scoped=true&"
import script from "./PostFormMentionsLegalesManage.vue?vue&type=script&lang=js&"
export * from "./PostFormMentionsLegalesManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44787a88",
  null
  
)

export default component.exports